<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'USERS.TITLE' | translate }}
    </glxy-page-title>
    <glxy-page-actions>
      <button mat-stroked-button color="secondary" (click)="importUsersCallback(hasAccessToLists)">
        <mat-icon *ngIf="hasAccessToLists === false">lock</mat-icon>
        {{ 'USERS.IMPORT_USERS' | translate }}
      </button>
      <button mat-flat-button color="primary" (click)="createUserClick()">
        {{ 'USERS.CREATE_USER' | translate }}
      </button>
      <a mat-icon-button [routerLink]="'/customize-design/default-notifications'">
        <mat-icon color="primary">settings</mat-icon>
      </a>
    </glxy-page-actions>
  </glxy-page-toolbar>
  <glxy-page-wrapper [widthPreset]="'wide'">
    <ng-container
      *ngIf="{
        tabDetails: tabsDetails$ | async,
        users: users$ | async,
        busy: busy$ | async
      } as pageData"
    >
      <ng-container *ngIf="!!pageData.tabDetails && !!pageData.users; else loading">
        <ng-container *ngIf="pageData.users?.length > 0 || hideEmptyState; else emptyState">
          <div class="table-header">
            <span>
              {{ 'USERS.LOGIN_URL_SUBTITLE' | translate }}
              <a [href]="loginUrl" target="_blank">{{ loginUrlText }}</a>
            </span>
          </div>
          <mat-card appearance="outlined" style="padding: 0">
            <va-filter-container
              (searchTermChanged)="updateSearchTerm($event)"
              [toolbarText]="
                'COMMON.TABLE.SHOWING_PAGE_OF_TOTAL'
                  | translate
                    : {
                        page: (pageData.users || []).length,
                        total: usersService.totalResults
                      }
              "
            >
              <span header class="header-button-wrapper" *ngIf="displayBulkActions">
                <button mat-raised-button mat-button class="header-button" (click)="navigateToBulkActions()">
                  {{ buttonTextDisplay$ | async }}
                </button>
              </span>
              <va-table
                content
                [tableViewModel]="usersTable"
                [items]="pageData.users"
                [sort]="initialSort"
                [sorting]="pageData.busy"
                [loadingMore]="pageData.busy"
                [showLoadMore]="usersService.hasMoreResults | async"
                [fixedLayout]="false"
                (sortChanged)="onSort($event)"
              ></va-table>
            </va-filter-container>
          </mat-card>
        </ng-container>
      </ng-container>
    </ng-container>
  </glxy-page-wrapper>
</glxy-page>

<ng-template #emptyState>
  <glxy-empty-state>
    <glxy-empty-state-hero>
      <img
        [src]="getImageSrc('images/empty-state/users-empty-state.png')"
        [alt]="'USERS.USERS_EMPTY_STATE' | translate"
      />
    </glxy-empty-state-hero>
    <glxy-empty-state-title>
      {{ 'USERS.EMPTY_STATE.TITLE' | translate }}
    </glxy-empty-state-title>
    <p>{{ 'USERS.EMPTY_STATE.DESCRIPTION' | translate }}</p>
    <glxy-empty-state-actions>
      <a mat-flat-button color="primary" (click)="navigateToURL('/bc-admin/user/create/')">
        {{ 'USERS.EMPTY_STATE.CTA' | translate }}
      </a>
    </glxy-empty-state-actions>
  </glxy-empty-state>
</ng-template>

<ng-template #loading>
  <mat-spinner class="loading-spinner" [diameter]="50"></mat-spinner>
</ng-template>
